import React from 'react';
import { connect } from 'react-redux';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { mapDesignationsConfig } from '../../entity/designations/mapDesignationsConfig';
import BaseComponent from '../../components/BaseComponent';

class MapDesignations extends BaseComponent {
  constructor(props: any) {
    super(props);
    this.config = { ...mapDesignationsConfig };
    this.getResponse();
  }
}

const mapStateToProps = (state: {
  app: { isAuthenticated: any; user: any };
}) => ({
  isAuthenticated: state.app.isAuthenticated,
  user: state.app.user,
});

const MapDesignationsWrapper = (props: any) => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();

  return (
    <MapDesignations
      {...props}
      navigate={navigate}
      location={location}
      params={params}
    />
  );
};

export default connect(mapStateToProps)(MapDesignationsWrapper);
